import { useTranslation } from "@/plugins/i18next/i18next";
import { cloneDeep } from "lodash-es";
export function useFormFieldPossibleTranslation() {
    const { t } = useTranslation();
    function formFieldPossibleTranslation(possibleValues) {
        return cloneDeep(possibleValues).map((x) => {
            if (x.translationKey) {
                x.text = t(x.translationKey, x.text);
            }
            return x;
        });
    }
    return {
        formFieldPossibleTranslation
    };
}
